import { PromptVersionDetails } from "./PromptVersionDetails";
import { ToolVersionDetails } from "./ToolVersionDetails";
import { DatasetVersionDetails } from "./DatasetVersionDetails";
import { EvaluatorVersionDetails } from "./EvaluatorVersionDetails";
import { File } from "@/types/app/file";
import { FlowVersionDetails } from "./FlowVersionDetails";
import { AgentVersionDetails } from "./AgentVersionDetails";
export const VersionDetails = ({ file, libraryView }: { file: File; libraryView?: boolean }) => {
  switch (file.type) {
    case "prompt":
      return <PromptVersionDetails version={file} />;
    case "tool":
      return <ToolVersionDetails tool={file} />;
    case "dataset":
      return <DatasetVersionDetails dataset={file} />;
    case "evaluator":
      return <EvaluatorVersionDetails version={file} />;
    case "flow":
      return <FlowVersionDetails version={file} />;
    case "agent":
      return <AgentVersionDetails version={file} libraryView={libraryView} />;
    default: {
      const _exhaustiveCheck: never = file;
    }
  }
};
export default VersionDetails;
